// Central per-route SEO metadata for the Mokshiq site.
// Keep titles ~50-60 chars and descriptions ~140-160 chars — anything
// longer gets truncated in Google's SERP snippet.
//
// Used by <RouteSeo /> in App.js, which looks up the current
// location.pathname in this map and renders <Seo {...meta} />.

const seoConfig = {
  '/': {
    title: 'Mokshiq | AEPS, DMT & Fintech API Provider in India',
    description:
      'Mokshiq by Rakle Service Private Limited offers AEPS, DMT, recharge, bill payment, and verification APIs with white-label B2B software for fintech businesses across India.',
    keywords:
      'AEPS API provider, DMT API, recharge API, fintech software India, white label B2B recharge software, Mokshiq',
  },
  '/about_us': {
    title: 'About Us | Mokshiq – Rakle Service Private Limited',
    description:
      'Learn about Mokshiq, a fintech and software product by Rakle Service Private Limited, our mission, security standards, and 24x7 support for AEPS, DMT, and API banking clients.',
    keywords: 'about Mokshiq, Rakle Service Private Limited, fintech company Noida',
  },
  '/contact_us': {
    title: 'Contact Us | Mokshiq Fintech & Software Support',
    description:
      'Get in touch with Mokshiq for AEPS, DMT, recharge API, or custom software queries. Call +91 7311104571 or email sales@mokshiq.in. Office: Sector-2, Noida.',
    keywords: 'contact Mokshiq, Mokshiq support, Mokshiq office Noida',
  },
  '/career': {
    title: 'Careers at Mokshiq | Join Rakle Service Private Limited',
    description:
      'Explore open positions at Mokshiq. Join a fast-growing fintech and software team building AEPS, DMT, recharge, and verification APIs used across India.',
    keywords: 'Mokshiq careers, fintech jobs Noida, Rakle Service Private Limited jobs',
  },
  '/join_us': {
    title: 'Apply Now | Mokshiq Careers',
    description:
      'Submit your application to join the Mokshiq team at Rakle Service Private Limited. Upload your resume and apply for open fintech and software roles.',
    keywords: 'apply Mokshiq job, Mokshiq career application',
  },
  '/blog': {
    title: 'Blog | Fintech, AEPS & API Insights by Mokshiq',
    description:
      'Read the Mokshiq blog for insights on AEPS, DMT, recharge APIs, digital payments, verification technology, and fintech industry trends in India.',
    keywords: 'fintech blog India, AEPS blog, Mokshiq blog',
  },
  '/blog_detail': {
    title: 'Blog Article | Mokshiq',
    description:
      'In-depth articles on AEPS, DMT, recharge APIs, digital payments, and fintech software trends from the Mokshiq team.',
    keywords: 'Mokshiq blog article',
  },
  '/services': {
    title: 'Our Services | Fintech, Software & API Solutions – Mokshiq',
    description:
      'Explore Mokshiq\'s full service catalogue: AEPS, DMT, recharge & bill payment APIs, verification APIs, CRM, hosting, web design, and digital marketing.',
    keywords: 'Mokshiq services, fintech API services, software services India',
  },
  '/service_details': {
    title: 'Service Details | Mokshiq',
    description:
      'Detailed specifications, API samples, and features for Mokshiq fintech and software services, provided by Rakle Service Private Limited.',
    keywords: 'Mokshiq service details',
    noindex: true, // content is driven by a ?title= query param on one shared URL — see README
  },
  '/privacy_policy': {
    title: 'Privacy Policy | Mokshiq',
    description:
      'Read the Mokshiq privacy policy to understand how Rakle Service Private Limited collects, uses, and protects your personal and transaction data.',
    keywords: 'Mokshiq privacy policy',
  },
  '/terms_of_conditions': {
    title: 'Terms & Conditions | Mokshiq',
    description:
      'Review the terms and conditions governing the use of Mokshiq\'s AEPS, DMT, recharge, and API banking services provided by Rakle Service Private Limited.',
    keywords: 'Mokshiq terms and conditions',
  },
  '/refund_and_cancellation': {
    title: 'Refund & Cancellation Policy | Mokshiq',
    description:
      'Understand Mokshiq\'s refund and cancellation policy for AEPS, DMT, recharge, bill payment, and Verify API transactions.',
    keywords: 'Mokshiq refund policy, cancellation policy fintech',
  },
  '/sprintverify': {
    title: 'Verify API Suite | Aadhaar, PAN & Bank Verification – Mokshiq',
    description:
      'Mokshiq Verify API offers instant Aadhaar OTP, PAN card, bank account penny drop, GSTIN, vehicle RC, and digital KYC verification for businesses.',
    keywords:
      'PAN verification API, Aadhaar OTP API, bank account verification API, penny drop API, GSTIN verification API, KYC API India',
  },
  '/recharge_api': {
    title: 'Recharge API | Mobile, DTH & Bill Payment API – Mokshiq',
    description:
      'Integrate Mokshiq\'s prepaid mobile, DTH, and bill payment recharge API with automatic LAPU switching, instant refunds, and 99.9% uptime SLA.',
    keywords: 'recharge API provider, mobile recharge API, DTH recharge API, LAPU switching API',
  },
  '/aeps_dmt_services': {
    title: 'AEPS & DMT Services | Aadhaar Payment & Money Transfer API – Mokshiq',
    description:
      'Mokshiq AEPS and DMT services enable Aadhaar-enabled cash withdrawal, mini statement, and domestic money transfer with bank-grade security.',
    keywords:
      'AEPS API, DMT API, Aadhaar enabled payment system, domestic money transfer API, micro ATM software',
  },
  '/b2b_recharge_software': {
    title: 'B2B Recharge Software | White-Label Distributor Portal – Mokshiq',
    description:
      'Launch a fully white-label B2B mobile recharge software with multi-tier distributor and retailer management, custom branding, and commission control.',
    keywords: 'B2B recharge software, white label recharge portal, distributor retailer software',
  },
  '/android_app_development': {
    title: 'Android App Development | Fintech & Custom Apps – Mokshiq',
    description:
      'Mokshiq builds custom Android and hybrid applications, including white-label fintech recharge apps, for businesses across India.',
    keywords: 'Android app development company, fintech app development, custom software development India',
  },
  '/hosting_services': {
    title: 'Web Hosting Services | Linux, Windows & VPS – Mokshiq',
    description:
      'Reliable Linux cPanel, Windows Plesk, VPS, and dedicated server hosting with free SSL, 1-click WordPress install, and 24x7 support from Mokshiq.',
    keywords: 'web hosting India, VPS hosting, dedicated server hosting, cPanel hosting',
  },
  '/utility_bill_payment': {
    title: 'Utility Bill Payment API (BBPS) | Mokshiq',
    description:
      'Mokshiq\'s BBPS-enabled utility bill payment API supports electricity, gas, water, and broadband bill payments with instant confirmation.',
    keywords: 'BBPS API, utility bill payment API, electricity bill payment API',
  },
  '/flight_booking_api': {
    title: 'Flight Booking API | Domestic & International – Mokshiq',
    description:
      'Integrate Mokshiq\'s flight booking API for real-time domestic and international fares, GDS access, and automated cancellation and refunds.',
    keywords: 'flight booking API, travel API India, GDS integration API',
  },
  '/crm_software_solutions': {
    title: 'CRM Software Solutions | Mokshiq',
    description:
      'Custom CRM software from Mokshiq to manage leads, sales pipelines, and customer relationships for fintech, corporate, and B2B businesses.',
    keywords: 'CRM software India, custom CRM development',
  },
  '/digital_marketing_solutions': {
    title: 'Digital Marketing & SEO Services | Mokshiq',
    description:
      'Mokshiq offers on-page and off-page SEO, Google PPC, and social media optimization services to grow organic traffic and leads for your business.',
    keywords: 'SEO services India, Google PPC agency, SMO services, digital marketing company Noida',
  },
  '/web_designing_services': {
    title: 'Web Designing & CMS Development Services | Mokshiq',
    description:
      'Custom responsive website design, UI/UX, and CMS development (WordPress and React) by Mokshiq — SEO-optimized and built for fast page speed.',
    keywords: 'web design company India, CMS development, WordPress development, React website development',
  },
  '/ecommerce_shopping': {
    title: 'E-Commerce Website & POS Software | Mokshiq',
    description:
      'Mokshiq builds e-commerce shopping websites and inventory POS billing software with GST invoicing, courier integration, and stock alerts.',
    keywords: 'e-commerce website development, inventory POS software, GST billing software',
  },
  '/indo_nepal_remittance': {
    title: 'Indo-Nepal Remittance API | Mokshiq',
    description:
      'Send cross-border remittances between India and Nepal instantly with Mokshiq\'s secure Indo-Nepal money transfer API.',
    keywords: 'Indo Nepal remittance API, India Nepal money transfer API',
  },
  '/fastag_recharge_api': {
    title: 'FASTag Recharge API | Mokshiq',
    description:
      'Integrate Mokshiq\'s FASTag recharge API for instant toll tag top-ups across all major issuing banks in India.',
    keywords: 'FASTag recharge API, FASTag API provider',
  },
  '/ott_subscription_api': {
    title: 'OTT Subscription Recharge API | Mokshiq',
    description:
      'Offer OTT platform subscription recharges through Mokshiq\'s API with instant activation and high commission margins.',
    keywords: 'OTT subscription API, OTT recharge API India',
  },
  '/courier_booking_api': {
    title: 'Courier Booking API | Logistics & Order Fulfillment – Mokshiq',
    description:
      'Compare courier rates and book shipments across major logistics partners with Mokshiq\'s courier booking and order fulfillment API.',
    keywords: 'courier booking API, logistics API India, shipment rate comparison API',
  },
  '/aadhaar_pay_merchant': {
    title: 'Aadhaar Pay Merchant Software | Mokshiq',
    description:
      'Mokshiq\'s Aadhaar Pay merchant software enables biometric-based cash payments and doorstep banking for retail and merchant outlets.',
    keywords: 'Aadhaar Pay software, Aadhaar Pay merchant API',
  },
  '/micro_atm_pos': {
    title: 'Micro ATM (mATM) POS Software | Mokshiq',
    description:
      'Deploy Mokshiq\'s Micro ATM POS software for Aadhaar-enabled cash withdrawal, balance enquiry, and mini statement services at retail points.',
    keywords: 'Micro ATM software, mATM POS software, Aadhaar enabled Micro ATM',
  },
};

export default seoConfig;